import React from 'react'

const VirticalArrowIcon = (props) =>(
	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="18" viewBox="0 0 12 18">
	  <path id="Union_31" data-name="Union 31" d="M12738.239,24381l-3.838-6,10.105,6-10.105,6Zm-4.459,1v-2h2.081v2Zm-3.637,0v-2h2.073v2Zm-3.637,0v-2h2.081v2Z" transform="translate(24387.004 -12726.507) rotate(90)" fill={props.fill}/>
	</svg>
)

export default VirticalArrowIcon